// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GHz5","right":"styles_right__xvdX6"};